webpackJsonp([176236309070072],{

/***/ 297:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fa = __webpack_require__(14);
	
	__webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationsList = function LocationsList(props) {
	  return _react2.default.createElement(
	    "section",
	    { className: "location page-content", id: "location" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "card-deck" },
	          props.data.map(function (item, i) {
	            return _react2.default.createElement(
	              "div",
	              { className: "card" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "card-title" },
	                  item.title
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  item.address.street
	                ),
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  item.address.statecity,
	                  " ",
	                  item.address.zip
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "card-text" },
	                  _react2.default.createElement(
	                    "small",
	                    { className: "text-muted" },
	                    item.description
	                  )
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "tel:" + item.phone.replace(/\D/g, ""),
	                    "class": "btn btn-outline-primary card-btn"
	                  },
	                  _react2.default.createElement(_fa.FaPhone, null),
	                  " ",
	                  item.phone
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "mailto:" + item.email,
	                    "class": "btn btn-outline-secondary"
	                  },
	                  _react2.default.createElement(_fa.FaEnvelope, null),
	                  " ",
	                  item.email
	                )
	              ),
	              _react2.default.createElement("img", {
	                className: "card-img-bottom",
	                src: item.image,
	                alt: "item image",
	                style: {
	                  height: 300,
	                  background: "transparent no-repeat center",
	                  backgroundSize: "cover"
	                }
	              })
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = LocationsList;
	module.exports = exports["default"];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(29);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _breadcrumb = __webpack_require__(15);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _locationsList = __webpack_require__(137);
	
	var _locationsList2 = _interopRequireDefault(_locationsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global graphql */
	
	var LocationsPage = function LocationsPage(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_nav2.default, null),
	    _react2.default.createElement(_breadcrumb2.default, { title: "Locations" }),
	    _react2.default.createElement(_locationsList2.default, { data: props.data.dataJson.locations })
	  );
	};
	
	exports.default = LocationsPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-locations-js-f7e389d1c9330ab97d70.js